import { render, staticRenderFns } from "./VerificationEmailSendCard.vue?vue&type=template&id=1e8a77f4"
import script from "./VerificationEmailSendCard.vue?vue&type=script&lang=js"
export * from "./VerificationEmailSendCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e8a77f4')) {
      api.createRecord('1e8a77f4', component.options)
    } else {
      api.reload('1e8a77f4', component.options)
    }
    module.hot.accept("./VerificationEmailSendCard.vue?vue&type=template&id=1e8a77f4", function () {
      api.rerender('1e8a77f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/VerificationEmailSendCard.vue"
export default component.exports